export const useStyles = (theme) => ({
  root: {
    width: "100%",
    paddingTop: 20,
    paddingBottom: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  gridContainer: {
    width: "100%",
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: 20,
    paddingTop: 15,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 10,
    },
  },
  gridItem: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      justifyContent: "center",
    },
  },
  paginationStyle: {
    padding: 10,
    display: "flex",
    justifyContent: "center",
  },
  bookStyle: {
    backgroundColor: "#f9f9fb",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.6,
    },
  },
  notificationStyle: {
    top: 80,
    right: 10,
  },
  bookItem: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  bookCoverStyle: {
    display: "flex",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.6,
    },
  },
  coverImageStyle: {
    width: 200,
    height: 260,
    [theme.breakpoints.down("sm")]: {
      width: 250,
      height: 350,
    },
  },
  bookBody: {
    width: "100%",
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  buttonStyle: {
    variant: "outlined",
    textTransform: "none",
    fontSize: 18,
    backgroundColor: "#d0d84f !important",
    outlineColor: "#d0d84f !important",
    marginBottom: 20,
    [theme.breakpoints.down("sm")]: {
      marginRight: 10,
    },
  },
  buttonItem: {
    paddingTop: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
